import { Preview } from "../../../../types/IAction";
import * as actions from "../../../actions/comisionAnualidad";
import { GetComisionAlcanceAnualidad } from "../../../reducers/comisionAnualidad";

export interface ConfiguracionAlcancesDispatcher {
  getComisionAlcanceAnualidadByTipos: () => Promise<
    Preview<GetComisionAlcanceAnualidad>
  >;
}

export const configuracionAlcancesDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => ConfiguracionAlcancesDispatcher = dispatch => ({
  getComisionAlcanceAnualidadByTipos: () => {
    return dispatch(actions.getComisionAlcanceAnualidadByTipos());
  }
});
